module.exports = __webpack_public_path__ + "static/media/brittany_philip.dbeeccbf.png";